import components from './components/index';
import metaInfo from './meta-info.json';
import views from './views/index';

export default {
  components,
  metaInfo,
  views,
};
